module.exports = __webpack_public_path__ + "img/ditan_yj_linhui.39e6e76a.jpg";